import React from 'react';
import { Sun, Moon, CalendarX, Clock } from 'lucide-react';
import { timings } from '../data/mock';

const iconMap = { Sun, Moon, CalendarX };

export default function Timings() {
  return (
    <section className="relative bg-slate-50 py-20 md:py-28 border-t border-slate-100">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <p className="section-eyebrow text-blue-600">Opening Hours</p>
          <h2 className="mt-4 font-anton text-3xl sm:text-4xl md:text-6xl leading-[0.95] text-slate-900">
            GYM <span className="text-blue-600">TIMINGS</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {timings.map((t, i) => {
            const Icon = iconMap[t.icon] || Clock;
            const isDark = t.tone === 'dark';
            return (
              <div
                key={t.label}
                className={`relative rounded-2xl p-7 text-center fade-up transition-all hover:-translate-y-1 ${
                  isDark
                    ? 'bg-slate-950 text-white ring-1 ring-amber-500/30 shadow-xl'
                    : 'bg-white text-slate-900 ring-1 ring-slate-200 hover:shadow-xl'
                }`}
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className={`mx-auto w-14 h-14 rounded-2xl flex items-center justify-center ${
                  isDark ? 'bg-amber-500/15 text-amber-400' : 'bg-blue-50 text-blue-600'
                }`}>
                  <Icon className="w-6 h-6" />
                </div>
                <p className={`mt-4 section-eyebrow ${isDark ? 'text-white/70' : 'text-slate-500'}`}>{t.label}</p>
                <p className={`mt-2 font-anton text-2xl md:text-3xl inline-flex items-center gap-2 ${
                  isDark ? 'text-amber-400' : 'text-slate-900'
                }`}>
                  <Clock className="w-5 h-5" />
                  {t.time}
                </p>
                <p className={`mt-1 text-sm ${isDark ? 'text-white/60' : 'text-slate-500'}`}>{t.days}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
